import { useEffect } from 'react';
import { Flex, Loader, Text } from '@mantine/core';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

/**
 * Minimal callback page rendered inside the FTN signing popup.
 * After eID Easy redirects here post-signing, this component
 * sends a message to the opener window and closes the popup.
 *
 * The postMessage + window.close are in a useEffect with no deps,
 * so they fire on first mount regardless of translation loading state.
 */
export const EidEasyFtnCallback = () => {
	const tCommonUi = useTranslationCommonUi();
	const hasOpener = !!window.opener;

	useEffect(() => {
		if (window.opener) {
			window.opener.postMessage({ type: 'eid-easy-ftn-complete' }, window.location.origin);
		}
		setTimeout(() => {
			window.close();
		}, 1500);
	}, []);

	return (
		<Flex direction="column" align="center" justify="center" h="100vh" gap="md">
			<Loader size="md" />
			<Text fw={600}>{tCommonUi('eid_easy_signing.signing_complete')}</Text>
			<Text size="sm" c="dimmed">
				{hasOpener
					? tCommonUi('eid_easy_signing.window_will_close')
					: tCommonUi('eid_easy_signing.close_window_manually')}
			</Text>
		</Flex>
	);
};
